import i18n from '../i18n'

export class NumberValidation{
  constructor(value) {
    this.value = value
    this.error = ''
  }

  validExists() {
    if(this.value === "" || this.value === null || this.value === undefined) {
      this.error = i18n.t('validation:please_input')
      return false
    }
    return true
  }

  validMaxLimit(max) {
    if(String(this.value).length > max) {
      this.error = i18n.t('validation:should_be_less_than_num', {n: max})
      return false
    }
    return true
  }
  validNum(){
    if(isNaN(this.value)){
      this.error = i18n.t('validation:should_be_number')
      return false
    }
    return true
  }

  validPrice(){
    if(isNaN(this.value.replace(/,/g, ''))){
      this.error = i18n.t('validation:should_be_number')
      return false
    }
    return true
  }

  validPriceMin(min, unit){
    if(!this.validPrice()){
      return false
    }else if (Number(this.value.replace(/,/g, '')) < min){
      this.error = i18n.t('validation:should_be_more_than_price', {n: min, u: unit})
      return false
    }
    return true
  }

  validPriceMax(max, unit){
    if(!this.validPrice()){
      return false
    }else if (this.value.replace(/,/g, '') > max){
      this.error = i18n.t('validation:should_be_less_than_num', {n: max + unit})
      return false
    }
    return true
  }

  validNumberMax(max) {
    if(!this.validNum()){
      return false
    }else if(this.value > max){
      this.error = i18n.t('validation:should_be_less_than_num', {n: max})
      return false
    }
    return true
  }

  validNumberMin(min){
    if(!this.validNum()){
      return false
    }else if (this.value < min){
      this.error = i18n.t('validation:should_be_more_than_num', {n: min})
      return false
    }
    return true
  }
}

export class PhotoValidation {
  constructor(file) {
    this.file = file
    this.error = ''
  }

  static extensionErrorMessage() {
    return i18n.t('validation:image_extension_jpeg_png')
  }

  get extension() {
    return this.file.type.split('/')[1]
  }

  validExtension() {
    const allowExtensionRegExp = /(jpg|jpeg|png)$/i

    if (!allowExtensionRegExp.test(this.extension)) {
      this.error = PhotoValidation.extensionErrorMessage()
      return false
    }
    return true
  }
}

export class DateValidation{
  constructor(value) {
    this.error = ''
  }
  isValidDateOrder(startDate, endDate){
    const s = new Date(startDate)
    const e = new Date(endDate)
    if (s > e){
      this.error = "開始日は終了日よりも前に設定お願いします。"
      return false
    }else{
      return true
    }
  }
}

export class PresenceValidation{
  constructor(error) {
    this.error = error
  }

  isValid(state, keys){
    for ( let k of keys ) {
      if ( state[k].length == 0 ) {
        this.error[k] = i18n.t('validation:please_input')
      }
    }
  }
}

/**
 * 指定された画像について、サイズ（width, height）のチェックを行う。
 * @param img 画像
 * @returns {boolean} チェックNGであればtrue
 */
export const isInvalidVerticalOrHorizontalSize = (img, width, height) => {

  return (
    img.width < width || img.height < height
  )
}

/**
 * アップロード画像をリサイズし、容量が指定サイズを超えているかどうかチェックする。
 * @param  {} img アップロード画像
 * @param  {number} maxSize
 * @returns {boolean} 指定されたサイズを超えていればtrue, そうでなければfalse
 */
export const isExceedImageSizeCapacity = (img, maxSize) => {
  const base64 = img.toDataURL('image/jpeg')
  const size = parseInt((base64).replace(/=/g, "").length * 0.75)
  return size / 1024 > maxSize
}
